import { useEffect, useRef } from 'react'

/** Poll only active work, retain the list, and resume immediately when the user returns. */
export function useVisibleRefresh(active: boolean, refresh: () => Promise<void>, intervalMs=4000) {
  const read = useRef(refresh)
  read.current = refresh
  useEffect(() => {
    let live = true, busy = false
    const tick = async () => {
      if (!live || busy || document.hidden) return
      busy = true
      try { await read.current() } finally { busy = false }
    }
    const timer = active ? window.setInterval(() => void tick(), Math.max(1000,Math.min(60000,intervalMs))) : undefined
    const resume = () => void tick()
    document.addEventListener('visibilitychange', resume)
    window.addEventListener('focus', resume)
    return () => {
      live = false
      if (timer !== undefined) window.clearInterval(timer)
      document.removeEventListener('visibilitychange', resume)
      window.removeEventListener('focus', resume)
    }
  }, [active,intervalMs])
}
